import { ClipboardListIcon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const ClipboardList = /* @__PURE__ */ createIcon(ClipboardListIcon, 'ClipboardList');
